<template>
    <div class="literacy_content">
        <el-scrollbar class="content">
            <div class="evaluation_list">
                <div class="list_item" v-for="(item, index) in evaluationList" :key="item.key">
                    <div class="title">
                        <span>{{ index + 1 }}、{{ item.name }}</span>
                    </div>
                    <div class="data_box">
                        <div class="data_list" v-for="childItem in item.chirldren" :key="childItem.key">
                            <span class="name">{{ childItem.name }}</span>

                            <!-- <span class="data-score">
                                {{ childItem.score ? childItem.score : "-" }}
                            </span> -->
                            <el-input-number
                                placeholder="0-100"
                                :precision="0"
                                v-model="childItem.score"
                                :controls="false"
                                class="pw-input"
                                style="width: 375px"
                                disabled
                            >
                            </el-input-number>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: "literacyAssment",
    data() {
        return {
            activeTabItem: 1,
            evaluationList: [],
            evaluationScore: 0,
            evaluationStatus: 0,
        };
    },
    components: {},
    methods: {
        clickTab(id) {},

        getLiteracyAssmentList() {
            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(this.$route.query.zhangIndex),
                course_node: Number(this.$route.query.jieIndex),
            };

            this.$shttp.axiosGetBy(this.$api.literacy_student_score_detail, params, (res) => {
                if (res.code === 200) {
                    this.evaluationScore = res.data.score;
                    this.evaluationStatus = res.data.status;
                    this.evaluationList = res.data.list || [];
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    mounted() {
        this.getLiteracyAssmentList();
    },
};
</script>

<style scoped lang="scss">
.literacy_content {
    width: 100%;
    height: 100%;
    background-color: #ffffff;

    .content {
        width: 100%;
        height: calc(100vh - 120px);
        padding: 20px 44px;
        box-sizing: border-box;

        ::v-deep .el-scrollbar__wrap::-webkit-scrollbar {
            display: none;
        }

        .evaluation_list {
            height: 100%;
            padding: 20px 30px;
            background: #f2f6fa;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #ededed;

            .list_item {
                .title {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 20px;
                    color: #333333;
                    line-height: 23px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    padding: 20px 0;
                }

                .data_box {
                    padding: 0 20px;

                    .data_list {
                        padding: 5px 0 12px 0;
                        display: flex;
                        align-items: center;

                        .name {
                            width: 180px;
                            display: flex;
                            justify-content: end;
                            margin-right: 20px;
                        }

                        .el-form-item {
                            margin-bottom: 0px;
                        }
                    }
                }
            }
        }
    }
}
::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>
